/* ============ CLAIRVEX — global JS ============ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Mobile nav ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) {
      var nav = $('[data-site-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = $('input', btn.closest('.qty'));
    var val = (parseInt(input.value, 10) || 1) + (btn.dataset.qty === 'up' ? 1 : -1);
    input.value = val < 1 ? 1 : val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- PDP gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = $('[data-gallery-main] img', gallery);
    if (main) { main.src = thumb.dataset.thumb; main.srcset = ''; }
    $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  });

  /* ---- Accordion ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.accordion__btn');
    if (!btn) return;
    var item = btn.closest('.accordion__item');
    var panel = $('.accordion__panel', item);
    var open = item.classList.toggle('is-open');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
  });

  /* ---- Size guide modal ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-size-guide-open]')) { var m = $('#size-guide'); if (m) m.classList.add('is-open'); }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal')) {
      $$('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    }
  });

  /* ---- Bundle builder (interactive: per-item size & color) ---- */
  var bundlexAdd = null;
  (function () {
    var bundlex = $('[data-bundlex]');
    if (!bundlex) return;
    var bdata = JSON.parse($('[data-bundlex-data]', bundlex).textContent);
    var totalEl = $('[data-bundlex-total]', bundlex);
    var mainImg = $('[data-gallery-main] img');
    var galleryMain = $('[data-gallery-main]');
    var baseSrc = mainImg ? mainImg.src : '';
    var activeItems = null; // container for the currently selected tier

    function firstAvailableOptions() {
      var v = bdata.variants.find(function (x) { return x.available; }) || bdata.variants[0];
      return v ? v.options.slice() : [];
    }
    var defaults = (bdata.default && bdata.default.length) ? bdata.default.slice() : firstAvailableOptions();
    var imgOptIdx = (function () { for (var i = 0; i < bdata.options.length; i++) { if (/colou?r/i.test(bdata.options[i].name)) return i; } return 0; })();

    function findVariant(vals) {
      return bdata.variants.find(function (v) {
        return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
      });
    }

    function esc(s) { return String(s).replace(/"/g, '&quot;'); }

    function swapImage(v) {
      if (mainImg && v && v.img) { mainImg.src = v.img; mainImg.srcset = ''; }
    }

    // Split the gallery into N panels — one per chosen item/color. Fully defensive: any
    // failure falls back to the normal single image, so it can never break the page.
    function renderSplit(variants) {
      try {
        if (!galleryMain) return;
        var split = galleryMain.querySelector('.pdp__split');
        var list = (variants || []).filter(function (v) { return v; });
        if (list.length <= 1) {
          if (split) split.parentNode.removeChild(split);
          if (mainImg) { mainImg.style.display = ''; if (list[0] && list[0].img) { mainImg.src = list[0].img; mainImg.srcset = ''; } }
          return;
        }
        if (mainImg) mainImg.style.display = 'none';
        if (!split) {
          split = document.createElement('div');
          split.className = 'pdp__split';
          galleryMain.appendChild(split);
        }
        split.setAttribute('data-count', list.length);
        var html = '';
        list.forEach(function (v) {
          var src = (v && v.img) ? v.img : baseSrc;
          html += '<div class="pdp__split-cell"><img src="' + src + '" alt="" loading="lazy"></div>';
        });
        split.innerHTML = html;
      } catch (e) {
        // On any error, restore the single image so the page stays intact.
        if (mainImg) mainImg.style.display = '';
      }
    }

    // Read the currently chosen variant for each row of the active tier, update the split.
    function findVariantByColor(vals) {
      var cv = vals[imgOptIdx];
      if (!cv) return undefined;
      return bdata.variants.find(function (v) { return v.options[imgOptIdx] === cv; });
    }

    function syncGallery() {
      try {
        if (!activeItems) { renderSplit(null); return; }
        var rows = $$('.bundlex__item', activeItems);
        var vs = rows.map(function (row) {
          return findVariantByColor($$('select', row).map(function (x) { return x.value; }));
        });
        renderSplit(vs);
      } catch (e) { /* no-op: keep single image */ }
    }

    function buildRow(i) {
      var row = document.createElement('div');
      row.className = 'bundlex__item';
      var html = '<span class="bundlex__item-num">' + (i + 1) + '</span><div class="bundlex__selects">';
      bdata.options.forEach(function (opt, oi) {
        html += '<label class="bundlex__field"><span class="bundlex__field-label">' + opt.name + '</span><span class="bundlex__select"><select data-opt="' + oi + '" aria-label="Item ' + (i + 1) + ' ' + esc(opt.name) + '">';
        html += '<option value="" selected disabled>Select ' + esc(opt.name.toLowerCase()) + '</option>';
        opt.values.forEach(function (val) {
          html += '<option value="' + esc(val) + '">' + val + '</option>';
        });
        html += '</select></span></label>';
      });
      html += '</div><span class="bundlex__item-status" data-row-status></span>';
      row.innerHTML = html;
      return row;
    }

    function setWarning(msg) {
      var warn = $('[data-atc-warning]');
      var warnText = $('[data-atc-warning-text]');
      if (!warn) return;
      if (msg) { if (warnText) warnText.textContent = msg; warn.style.display = 'flex'; }
      else { warn.style.display = 'none'; }
    }

    function validate() {
      if (!activeItems) { setWarning(''); return true; }
      var rows = $$('.bundlex__item', activeItems);
      var allOk = true;
      var message = '';
      rows.forEach(function (row) {
        var vals = $$('select', row).map(function (s) { return s.value; });
        var incomplete = vals.some(function (x) { return !x; });
        var v = findVariant(vals);
        var status = $('[data-row-status]', row);
        if (incomplete) {
          if (!message) {
            var missing = [];
            bdata.options.forEach(function (opt, oi) { if (!vals[oi]) missing.push(opt.name.toLowerCase()); });
            message = 'Select a ' + missing.join(' and a ');
          }
          if (status) { status.textContent = ''; status.className = 'bundlex__item-status'; }
          allOk = false;
        } else if (!v || !v.available) {
          if (!message) message = 'That color & size is sold out';
          if (status) { status.textContent = 'Sold out'; status.className = 'bundlex__item-status is-bad'; }
          allOk = false;
        } else if (status) { status.textContent = '✓'; status.className = 'bundlex__item-status is-ok'; }
      });
      setWarning(allOk ? '' : message);
      var addBtn = $('[data-add-to-cart]');
      if (addBtn) addBtn.disabled = !allOk;
      return allOk;
    }

    function renderRows(container, qty) {
      // clear every tier's items, then fill the active one
      $$('[data-tier-items]', bundlex).forEach(function (c) { c.innerHTML = ''; });
      activeItems = container;
      if (!container || !bdata.options.length) { validate(); return; }
      for (var i = 0; i < qty; i++) container.appendChild(buildRow(i));
      $$('select', container).forEach(function (s) {
        s.addEventListener('change', function () {
          syncGallery();
          validate();
        });
      });
      validate();
    }

    function setTier(input) {
      if (!input) return;
      var wrap = input.closest('.bundlex__tier-wrap');
      $$('.bundlex__tier', bundlex).forEach(function (t) { t.classList.toggle('is-active', t.contains(input)); });
      if (totalEl && input.dataset.total) totalEl.textContent = input.dataset.total;
      renderRows(wrap ? $('[data-tier-items]', wrap) : null, parseInt(input.dataset.qty, 10) || 1);
    }

    bundlex.addEventListener('change', function (e) {
      var t = e.target.closest('input[name="bundle-tier"]');
      if (t) setTier(t);
    });
    setTier($('input[name="bundle-tier"]:checked', bundlex) || $('input[name="bundle-tier"]', bundlex));

    bundlexAdd = function () {
      var rows = activeItems ? $$('.bundlex__item', activeItems) : [];
      var items = [];
      if (!rows.length) {
        var qty = parseInt(($('input[name="bundle-tier"]:checked', bundlex) || {}).dataset.qty || 1, 10);
        items.push({ id: bdata.variants[0].id, quantity: qty });
      } else {
        if (!validate()) { flash('Pick an available size & color for each item'); return; }
        var map = {};
        rows.forEach(function (row) {
          var vals = $$('select', row).map(function (s) { return s.value; });
          var v = findVariant(vals);
          if (v) map[v.id] = (map[v.id] || 0) + 1;
        });
        items = Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
      }
      var addBtn = $('[data-add-to-cart]');
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status) { flash(data.description || 'Could not add to bag'); }
        else { refreshCart(); openCart(); }
      }).catch(function () { flash('Something went wrong'); })
        .finally(function () { if (addBtn) addBtn.disabled = false; });
    };
  })();

  /* ---- Variant selection ---- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = $('[data-variants-json]', form);
    if (!dataEl) return;
    if ($$('[data-option-input]', form).length === 0) return; // bundle mode handles its own variants
    var variants = JSON.parse(dataEl.textContent);
    function update() {
      var selected = $$('[data-option-input]:checked', form).map(function (i) { return i.value; });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      var idInput = $('[name="id"]', form);
      var addBtn = $('[data-add-to-cart]', form);
      var priceNow = $('[data-price-now]');
      if (match) {
        idInput.value = match.id;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.querySelector('[data-atc-label]').textContent = match.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
        }
        if (priceNow && match.price) priceNow.textContent = match.price;
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.querySelector('[data-atc-label]').textContent = addBtn.dataset.labelUnavailable;
      }
      $$('[data-swatch-label]').forEach(function (el) {
        var sel = $$('[data-option-input]:checked', form)[0];
        if (sel && el.dataset.optionPos === '1') el.textContent = sel.value;
      });
    }
    $$('[data-option-input]', form).forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  /* ---- Flash + cart count ---- */
  function flash(msg) {
    var el = $('#cart-flash'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
      renderCartDrawer(cart);
    });
  }

  /* ---- Cart drawer ---- */
  var CART_FREE_SHIP = 5000; // cents ($50)
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function openCart() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function renderCartDrawer(cart) {
    var body = $('[data-cartd-body]'); if (!body) return;
    var foot = $('[data-cartd-foot]'), empty = $('[data-cartd-empty]'), ship = $('[data-cartd-ship]');
    $$('[data-cartd-count]').forEach(function (e) { e.textContent = cart.item_count ? '(' + cart.item_count + ')' : ''; });

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '';
      if (foot) foot.style.display = 'none';
      if (ship) ship.style.display = 'none';
      if (empty) empty.style.display = 'flex';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (foot) foot.style.display = 'block';
    if (ship) ship.style.display = 'block';

    // always-free-shipping message
    var msg = $('[data-cartd-ship-msg]'), fill = $('[data-cartd-ship-fill]');
    if (msg) msg.innerHTML = "You've unlocked <strong>free shipping</strong> &#127881;";
    if (fill) fill.style.width = '100%';

    body.innerHTML = cart.items.map(function (it) {
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
      return '<div class="cartd__item" data-key="' + it.key + '">' +
        '<div class="cartd__item-img">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '') + '</div>' +
        '<div class="cartd__item-info">' +
          '<p class="cartd__item-title">' + it.product_title + '</p>' +
          (opts ? '<p class="cartd__item-variant">' + opts + '</p>' : '') +
          '<div class="cartd__item-bottom">' +
            '<div class="cartd__qty">' +
              '<button type="button" data-cartd-minus="' + it.key + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-cartd-plus="' + it.key + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cartd__item-price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cartd__item-remove" data-cartd-remove="' + it.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    var sub = $('[data-cartd-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
  }
  function changeCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
      renderCartDrawer(cart);
    });
  }
  // drawer events (delegated)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCartDrawer(c); openCart(); }); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var plus = e.target.closest('[data-cartd-plus]');
    var minus = e.target.closest('[data-cartd-minus]');
    var rm = e.target.closest('[data-cartd-remove]');
    if (plus || minus || rm) {
      var row = e.target.closest('.cartd__item'); if (!row) return;
      var key = row.getAttribute('data-key');
      var cur = parseInt($('.cartd__qty span', row).textContent, 10) || 1;
      if (plus) changeCart(key, cur + 1);
      else if (minus) changeCart(key, cur - 1);
      else if (rm) changeCart(key, 0);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  // populate drawer on load (so count/state correct)
  fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer).catch(function () {});

  /* ---- AJAX add to cart ---- */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (bundlexAdd) { bundlexAdd(); return; }
      var btn = $('[data-add-to-cart]', form);
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: $('[name="id"]', form).value, quantity: parseInt(($('[name="quantity"]', form) || {}).value || 1, 10) })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status) { flash(data.description || 'Could not add to cart'); }
        else { refreshCart(); openCart(); }
      }).catch(function () { flash('Something went wrong'); })
        .finally(function () { if (btn) { btn.disabled = false; } });
    });
  });

  /* ---- Cart line quantity ---- */
  $$('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var qty = parseInt(input.value, 10); if (isNaN(qty) || qty < 0) qty = 0;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.dataset.cartQty, quantity: qty }) })
        .then(function () { window.location.reload(); });
    });
  });

  /* ---- Collection sort ---- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---- Sticky add-to-cart bar ---- */
  var sticky = $('[data-sticky-atc]');
  var atcAnchor = $('[data-atc-anchor]');
  if (sticky && atcAnchor) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(atcAnchor);
    var stickyBtn = $('[data-sticky-add]', sticky);
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var f = $('[data-product-form]'); if (f) f.requestSubmit ? f.requestSubmit() : f.querySelector('[data-add-to-cart]').click();
    });
  }

  /* ---- Free-shipping progress bar (cart) ---- */
  $$('[data-ship-bar]').forEach(function (bar) {
    var threshold = parseInt(bar.dataset.shipBar, 10);
    var total = parseInt(bar.dataset.cartTotal, 10);
    var fill = $('.cart-bar__fill', bar);
    var msg = $('[data-ship-msg]', bar);
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (msg && total >= threshold) msg.textContent = "You've unlocked free shipping! 🎉";
  });
})();
